// extracted by mini-css-extract-plugin
export default {"modal":"ImageShowModal_modal__P-6yS","frame":"ImageShowModal_frame__XU2eH"};